
<a-select
    :options="displayRuleOptions"
    v-model.sync="localValue"
    :is-searchable="false"
    :has-teleport="!outsideModal"
    @blur="removeClass"
    @focus="addClass"
    @input="removeClass"
    @mouseenter="addClass"
    @mouseleave="removeClass"></a-select>
